import { useCallback, useEffect, useRef, useState } from 'react';
import { COPY_FEEDBACK_MS } from '@shared/lib/copy-feedback-duration';
import { copyToClipboard } from '@shared/lib/copy-to-clipboard';

export function useCopyFeedback(onCopied?: () => void) {
  const [copiedKey, setCopiedKey] = useState<string | null>(null);
  const timerRef = useRef<number | null>(null);

  useEffect(
    () => () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    },
    []
  );

  const copy = useCallback(
    async (value: string, key: string) => {
      if (!value) return;
      await copyToClipboard(value);
      setCopiedKey(key);
      onCopied?.();
      if (timerRef.current) window.clearTimeout(timerRef.current);
      timerRef.current = window.setTimeout(() => setCopiedKey(null), COPY_FEEDBACK_MS);
    },
    [onCopied]
  );

  return { copiedKey, copy };
}
